import { useEffect, useState } from "react";
 
 
 
const SubscriptionStatus = () => {
  const [trialDaysLeft, setTrialDaysLeft] = useState(null);
  const [endDateDaysLeft, setEndDateDaysLeft] = useState(null);
  const [subscriptionExpired, setSubscriptionExpired] = useState(false);
  const [freeTrial, setFreeTrial] = useState(false);
 
    var roleID =localStorage.getItem("roleID");
        var planName =localStorage.getItem("planName");
    const createdDateStr = localStorage.getItem("subscriptionStartDate");
    const endDateStr = localStorage.getItem("subscriptionEndDate");
    const isSubscriptionActive = localStorage.getItem("isSubscriptionActive");
 
   
  useEffect(() => {
 
    const today = new Date();
    today.setHours(0, 0, 0, 0);
 
    let subscriptionTaken = false;
 
    if (endDateStr) {
      const endDate = new Date(endDateStr);
      endDate.setHours(0, 0, 0, 0);
 
      const subscriptionDaysLeft = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
      if (subscriptionDaysLeft >= 0) {
        subscriptionTaken = true;
 
        if (subscriptionDaysLeft <=7) {
          setEndDateDaysLeft(subscriptionDaysLeft); // Show reminder only if about to end
        }
      }
    }
 
    // Show trial info only if no subscription was taken
    if (!subscriptionTaken && createdDateStr) {
      const createdDate = new Date(createdDateStr);
      createdDate.setHours(0, 0, 0, 0);
 
      const trialDaysUsed = Math.floor((today - createdDate) / (1000 * 60 * 60 * 24));
      const trialDaysRemaining = 7 - trialDaysUsed;
 
      if (trialDaysRemaining > 0) {
        setTrialDaysLeft(trialDaysRemaining); // Still in trial
      }
       else if(planName=='null'&& isSubscriptionActive=='true') {
        setFreeTrial(true); // Trial ended, no subscription
      } else {
        setSubscriptionExpired(true); // Trial ended, no subscription
      }
    }
  }, []);
 
 
  return (
      <>
{freeTrial && (
          <div style={{ backgroundColor: "#cce5ff", padding: "10px", borderRadius: "8px", marginBottom: "10px",marginTop:"10px" }}>
            <strong>Trial:</strong> free trial.
          </div>
        )}
        {trialDaysLeft !== null && (
          <div style={{ backgroundColor: "#cce5ff", padding: "10px", borderRadius: "8px", marginBottom: "10px",marginTop:"10px" }}>
            <strong>Trial:</strong> {trialDaysLeft} day{trialDaysLeft > 1 ? "s" : ""} left in your free trial.
          </div>
        )}
   
        {endDateDaysLeft !== null && (
          <div style={{ backgroundColor: "#fff3cd", padding: "10px", borderRadius: "8px", marginBottom: "10px",marginTop:"10px" }}>
            <strong>Reminder:</strong> Your subscription ends in <strong>{endDateDaysLeft} day{endDateDaysLeft > 1 ? "s" : ""}</strong>.
          </div>
        )}
   
        {subscriptionExpired && (
          <div style={{ backgroundColor: "#f8d7da", padding: "10px", borderRadius: "8px", marginBottom: "10px" ,marginTop:"10px"}}>
            <strong>Notice:</strong> {roleID === "3"
      ? "Your trial has ended. Please contact your admin to continue using the service."
      : "Your trial has ended. Please subscribe to continue using the service."}
 
          </div>
        )}
      </>
    );
   
 
};
 
 
 
export default SubscriptionStatus;
 
 